import { Notification } from "../models/notification";

export interface NotificationState {
    lastId: number;
    notifications: Notification[];
}

export const initialState: NotificationState = {
    lastId: 0,
    notifications: [],
};



// WEBPACK FOOTER //
// ./src/store/NotificationState.ts